<template>
  <v-alert
    v-if="show"
    :value="true"
    :color=alertClasses
    :icon=alertIcons
    dismissible
    outline
    @click=alertClose>
    {{ message }}
  </v-alert>
</template>

<script>
export default {

  watch: {
    show: function (val) {
      var self = this
      if (val === true) {
        if (this.alertClasses === 'error') {
          this.$ga.event({
            eventCategory: 'User Engagement',
            eventAction: 'Error displayed',
            eventLabel: this.message,
            eventValue: 0
          })
        }
        // timer autoclose
        setTimeout(function () {
          self.$store.dispatch('Alert/closeAlert')
        }, 10000)
      }
    }
  },

  computed: {
    alertIcons: function () {
      if (this.type === 'danger' || this.type === 'error') {
        return 'warning'
      }

      if (this.type === 'success') {
        return 'check_circle'
      }
      return 'info'
    },
    alertClasses: function () {
      if (this.type === 'danger' || this.type === 'error') {
        return 'error'
      }

      if (this.type === 'success') {
        return 'success'
      }

      return 'info'
    },
    message: function () {
      return this.$store.getters['Alert/getMessage']
    },
    type: function () {
      return this.$store.getters['Alert/getType']
    },
    show: function () {
      return this.$store.getters['Alert/getShow']
    }
  },

  methods: {
    alertClose: function () {
      this.$store.dispatch('Alert/closeAlert')
    }
  }
}
</script>
